import simpleRequest from './simple';
import auth from './auth';
import { get } from '../utils/index';
import localStorage from '@/utils/localStorage';

// NOTE:
// options.auth几种值的解释(虽然这个名字不是很恰当)
// - 'yes': 需要token，如果没有则直接登录
// - 'throw': 需要token，但如果没有的话并不直接登录而是抛出{ name:'AuthError', message:'...' }的错误
// - 'no': 不需要token
// - 'default'(默认): 有token就带上，没有就不带
//
// 各个request出错的返回值(按可能发生的先后顺序)：
// 1. 如果获取或刷新token的请求XHR出错，则抛出`Error`
// 2. 如果没获取到token，则抛出{ name:'AuthError', message:'...' }
// 3. 如果业务请求XHR出错，则抛出`Error`
// 4. 如果响应头content-type:application/json，JSON.parse可能会抛出`SyntaxError`
// 5. 如果返回值不满足特定条件（比如api接口返回的code!=1），则抛出{ name:'ResponseError', message:'...', data }
// 理论上获取token的请求也可能`SyntaxError`

// 目前涉及到的业务类型有:
// - API团队
//   - 机票
//   - 支付
// - H5团队Node
// 他们的域名或路径或参数可能有点差异

function addAuthorization(options) {
  const opts = {
    ...options
  };
  const setting = options && options.auth;

  if (setting === 'no') {
    return Promise.resolve(opts);
  }

  if (!opts.headers) {
    opts.headers = {};
  }

  if (!setting) {
    return Promise.resolve(auth.getSync()).then(({ Authorization }) => {
      if (Authorization) {
        opts.headers.Authorization = Authorization;
      }
      return opts;
    });
  }

  return auth.get().then(({ Authorization }) => {
    opts.headers.Authorization = Authorization;
    return opts;
  });
}

// refresh:
// (默认)为true表示如果服务器返回token失效，则刷新token后再重发一遍业务请求；
// 为false表示token失效时不刷新token也不重发请求，而是直接抛出错误
// -402: 访问token过期
// -401: 登录过期
const request_api = host => (options, refresh = true) => {
  let refreshcode = localStorage.get('refreshcode') || '';
  if (!refreshcode) refresh = false; //refreshcode为空则不需要刷新

  return addAuthorization(options).then(opts => {
    console.log(`@request.${host}`, options.data);
    return simpleRequest(host)(opts).then(r => {
      let code = get(r, 'res.hd.code');
      let desc = get(r, 'res.hd.desc');
      if (code == 1) {
        return r;
      } else if (code == -401 || code == -402) {
        if (refresh) {
          auth.refresh({
            invalidAuth: opts.headers.Authorization
          });
          return request_api(host)(options, false);
        } else {
          auth.logout(); //清除storage
          if (code == -401 && desc == '请先登录！') {
            desc = '登录状态过期，请重新登录';
          }
          throw {
            name: 'ResponseError',
            message: desc,
            data: r
          };
        }
      } else {
        throw {
          name: 'ResponseError',
          message: desc,
          data: r
        };
      }
    });
  });
};

const request_gaotie_api = host => (options, refresh = true) => {
  return addAuthorization(options).then(opts => {
    console.log(`@request.${host}`, options.data);
    return simpleRequest(host)(opts).then(r => {
      let code = get(r, 'code');

      if (get(r, 'hd')) {
        code = get(r, 'hd.code');
      }
      if (code == 1) {
        return r;
      } else if (refresh && (code == -401 || code == -402)) {
        auth.refresh({
          invalidAuth: opts.headers.Authorization
        });
        return request_gaotie_api(host)(options, false);
      } else {
        let desc = get(r, 'msg');
        throw {
          name: 'ResponseError',
          message: desc,
          data: r
        };
      }
    });
  });
};

const request_old_pay_api = host => (options, refresh = true) => {
  return addAuthorization(options).then(opts => {
    console.log(`@request.${host}`, options.data);
    console.log('opts: ', opts);
    opts.data.loginAuthCode = localStorage.get('authcode') || '';
    return simpleRequest(host)(opts).then(r => {
      let code = get(r, 'res.hd.code');
      if (code == 1) {
        return r;
      } else if (refresh && (code == -401 || code == -402)) {
        auth.refresh({
          invalidAuth: opts.headers.Authorization
        });
        return request_old_pay_api(host)(options, false);
      } else {
        let desc = get(r, 'res.hd.desc');
        if (code == -401 && desc == '请先登录！') {
          desc = '登录态过期，请重新登录';
        }
        throw {
          name: 'ResponseError',
          message: desc,
          data: r
        };
      }
    });
  });
};

export default {
  ticket: request_api('ticket'),
  pay: request_api('pay'),
  defray: request_api('defray'),
  gaotie: request_gaotie_api('gaotie'),
  oldPay: request_old_pay_api('ticket'),
  gateway: request_api('ticket')
};



// WEBPACK FOOTER //
// ./src/request/index.js